import { Injectable } from '@angular/core';
import { SessionStorage } from 'ngx-webstorage';
import { BrowserStack } from 'protractor/built/driverProviders';
import { ApplicationConfig, EmployeeDetails, TimeSheetEntry } from '../models/config';

@Injectable()
export class ConfigService {

  /**
   * @field config
   */
  @SessionStorage('config') public config;

  /**
   * @description Contructor function for setting the default value for config Session Storage
   */
  constructor() {
    // this.config = new ApplicationConfig({});
  }


  /**
   * @description Setting the configuration of the application in Session Storage
   * @param config
   * @returns void
   */
  // config: ApplicationConfig
  setConfig(businessUnit): void {
    if (!!businessUnit) {
      switch (businessUnit) {
        case 'ipdo': this.config = this.getBusinessUnitDetail(0);
          break;
        case 'accenture': this.config = this.getBusinessUnitDetail(1);
          break;
        case 'biologics': this.config = this.getBusinessUnitDetail(2);
          break;
        case 'chinateam': this.config = this.getBusinessUnitDetail(3);
          break;
        case 'aps': this.config = this.getBusinessUnitDetail(4);
          break;

      }
    }
  }

  /**
   * @description Unsetting the config object in Session storage
   * @returns boolean
   */
  unsetConfig(): boolean {
    return true;
  }

  /**
   * @description return the complete application configuration
   * @returns ApplicationConfig
   */
  getConfig(): ApplicationConfig {
    // return new ApplicationConfig(this.config);
    return this.config;
  }

  /**
   * @description return the Employee configuration from the Application config object
   * @returns EmployeeDetails
   */
  getEmployeeConfig(): EmployeeDetails {
    const employeeConfig = new ApplicationConfig(this.config);
    return employeeConfig.employee;
  }


  /**
   * @description return the timesheet configuration from the Application config object
   * @returns TimeSheetDetails
   */
  getTimesheetConfig(): TimeSheetEntry {
    const timesheet = new ApplicationConfig(this.config);
    return timesheet.timeSheetEntry;
  }

  /**
  * @description return the getBusinessUnitdetail
  * @returns BusinessUnbit detail
  */
  getBusinessUnitDetail(index) {

    const configuration = [
      /** IPDO Configration*/
      {
        businessUnit: "ipdo"
      },
      /** accenture Configration*/
      {
        businessUnit: "accenture"
      },
      /** biologics Configration*/
      {
        businessUnit: "biologics"
      },
      /** IPDO Configration*/
      {
        businessUnit: "chinateam"
      },
      /** aps Configration*/
      {
        businessUnit: "aps"
      }
    ]
    // const timesheet = new ApplicationConfig(this.config);
    return configuration[index];
  }

}

// if (this.loggedInUser.businessUnit === 'ipdo') {
//   this.loginConfig = {
//     'sap_integration': false,
//     'non_adherance': false,
//     'non_compliance': false,
//     'detailed_report' : true,
//     'summarized_report': false,
//     'employee': {
//       'addEmployee': false,
//       'updateEmployee': true,
//       'employee_list': 'ipdo',
//       'editEmployee': {
//         'name': false,
//         'emailId': false,
//         'no': false,
//         'reportingManagerCheck': false,
//         'reportingManagerId': false,
//         'reportingManager': false,
//         'role': false,
//         'team': false
//       }
//     },
//     'timeSheetEntry': {
//       'employeeType': 'rm',
//       'exceedTimeLimit' : '23:59',
//       'lessTimeLimit' : '4:30',
//       'saveTimeSheet' : true,
//       'submitDay': 'Monday'
//     }
//   };
// } else if (this.loggedInUser.businessUnit === 'accenture') {
//   this.loginConfig = {
//     'sap_integration': false,
//     'non_adherance': false,
//     'non_compliance': false,
//     'detailed_report' : false,
//     'summarized_report': true,
//     'employee': {
//       'addEmployee': true,
//       'updateEmployee': false,
//       'employee_list': 'accenture',
//       'editEmployee': {
//         'name': true,
//         'emailId': true,
//         'no': true,
//         'reportingManagerCheck': true,
//         'reportingManagerId': false,
//         'reportingManager': true,
//         'role': true
//       }
//     },
//     'timeSheetEntry': {
//       'employeeType': 'rm',
//       'lessTimeLimit' : '4.5',
//       'exceedTimeLimit' : '23.5',
//       'saveTimeSheet' : true,
//       'submitDay': 'Monday'
//     }
//   };
// }



// WEBPACK FOOTER //
// ./src/app/utils/services/config.service.ts